// /* eslint-disable react-hooks/exhaustive-deps */

// import { IconX } from "@tabler/icons-react";

// import { useState, useEffect, useCallback } from "react";

// import ButtonStyled from "../../../components/common/ButtonStyled";

// import RaidoField from "../../../components/common/RaidoField";

// import SelectInput from "../../../components/Select";

// import Input from "../../../components/Input";

// import ToggleButton from "../../../components/ToggleButton";

// import Checkbox from "../../../components/common/CheckBox";

// import { useFetchManifestById } from "../../../hooks/productManifest";

// import { useFetchAllPickupLocationData } from "../../../apis/pickupApis";

// import {

//   Control,

//   UseFormClearErrors,

//   UseFormRegister,

//   UseFormSetValue,

//   UseFormWatch,

// } from "react-hook-form";

// import { useSelector } from "react-redux";



// interface Product {

//   productId: string;

//   productName: string;

//   sku: string;

//   quantity?: number | null;

//   missingQty?: number | null;

//   damageQty?: number | null;

//   adminReason?: string | null; // This is the admin reason

//   clientReason?: string | null; // This is what the client inputs

//   confirmed?: boolean; // Added for the confirm checkbox state

//   note?: string | null; // For update mode note field

//   reservedQuantity?: number;

// }



// interface Props {

//   open: boolean;

//   onClose: () => void;

//   manifestId?: string;

//   register: UseFormRegister<any>;

//   setValue?: UseFormSetValue<any>;

//   watch?: UseFormWatch<any>;

//   errors?: any;

//   clearErrors?: UseFormClearErrors<any>;

//   control?: Control<any>;

//   handleSubmit: any;

// }



// const TwoCol: React.FC<{ label: string; value: React.ReactNode }> = ({

//   label,

//   value,

// }) => (

//   <p className="text-sm text-[#1E293B] flex items-center space-x-2">

//     <span className="font-normal text-sm text-[#212121]">{label}:</span>

//     <span>{value}</span>

//   </p>

// );



// const ProductRequestModal: React.FC<Props> = ({

//   open,

//   onClose,

//   manifestId,

//   register,

//   setValue,

//   watch,

//   errors,

//   control,

//   handleSubmit,

// }) => {

//   const profile = useSelector((state: any) => state.auth.profile);



//   const [isUpdateMode, setIsUpdateMode] = useState(false);

//   const [mode, setMode] = useState<"pickupRequest" | "dropRequest">(

//     "pickupRequest"

//   );

//   const [split, setSplit] = useState(false);

//   const { data: manifest } = useFetchManifestById(manifestId || "");

//   const { data: allPickupLocationData } = useFetchAllPickupLocationData();



//   // Pre-populate form fields with manifest data in update mode and view mode initially

//   useEffect(() => {

//     if (manifest && setValue) {

//       // Always set these when manifest loads, regardless of update mode

//       setValue("vehicleType", manifest.vehicleType);

//       setValue("locationId", manifest.locationId);

//       setValue(

//         "pickupDate",

//         manifest.pickupDate

//           ? new Date(manifest.pickupDate).toISOString().split("T")[0]

//           : ""

//       );

//       setValue("timeSlot", manifest.timeSlot);

//       setValue("requestType", manifest.requestType || mode);

//       setValue("packageType", manifest.packageType || "");



//       manifest.products?.forEach((item: Product, i: number) => {

//         setValue(`products[${i}].productId`, item.productId);

//         setValue(

//           `products[${i}].quantity`,

//           item.quantity !== undefined ? String(item.quantity) : ""

//         );

//         setValue(`products[${i}].missingQty`, item.missingQty ?? 0); // Initialize to 0 if null/undefined

//         setValue(`products[${i}].damageQty`, item.damageQty ?? 0); // Initialize to 0 if null/undefined

//         setValue(`products[${i}].clientReason`, item.clientReason ?? ""); // Ensure string

//         setValue(`products[${i}].confirmed`, item.confirmed ?? false); // Initialize confirmed status

//         setValue(`products[${i}].adminReason`, item.adminReason ?? "");

//         setValue(`products[${i}].reservedQuantity`, item.reservedQuantity ?? 0)

//       });

//     }

//   }, [manifest, setValue]); // Removed mode to prevent form values from being overwritten when mode changes



//   const toggleUpdateMode = useCallback(() => {

//     if (isUpdateMode) {

//       // Check if split is active and no items are selected

//       if (split) {

//         const selectedItems = manifest?.products?.filter((_: Product, i: number) => watch?.(`products[${i}].selected`));

//         if (!selectedItems || selectedItems.length === 0) {

//           alert("Please select at least one item when split is enabled");

//           return;

//         }

//       }

//       // When in update mode and clicking "Save", submit the form

//       handleSubmit();

//     } else {

//       // When in view mode and clicking "Update", switch to update mode

//       setIsUpdateMode(true);

//     }

//   }, [handleSubmit, isUpdateMode, split, manifest?.products, watch]);



//   const handleModeChange = useCallback(

//     (val: string | false | undefined) => {

//       if (typeof val === "string") {

//         setMode(val as "pickupRequest" | "dropRequest");

//         setValue?.("requestType", val);

//       }

//     },

//     [setValue]

//   );



//   const handleSplitToggle = useCallback(() => {

//     setSplit((prev) => !prev);

//   }, []);

//   // Update form value when split state changes
//   useEffect(() => {
//     if (setValue) {
//       setValue("split", split ? "true" : "false");
//     }
//   }, [split, setValue]);



//   const handleConfirmSubmit = useCallback(() => {

//     handleSubmit();

//   }, [handleSubmit, manifestId]);



//   const renderViewMode = () => {

//     return (

//       <>

//         <div className="col-span-full space-y-3 border-[1.5px] border-[#D2D2D2] p-3 rounded-lg">

//           <h3 className="text-[#212121]/70 font-medium text-sm uppercase">

//             Client Info

//           </h3>

//           <div className="grid grid-cols-2 gap-2">

//             <TwoCol label="Client ID" value={manifest?.clientId} />

//             <TwoCol label="Name" value={manifest?.clientName} />

//             <TwoCol label="Mobile" value={manifest?.clientMobileNo} />

//             <TwoCol label="Email" value={manifest?.clientEmail} />

//           </div>

//         </div>



//         <div className="col-span-full space-y-2 border-[1.5px] border-[#D2D2D2] p-3 rounded-lg">

//           <h3 className="text-[#212121]/70 font-medium text-sm uppercase">

//             Product Info ({manifest?.products?.length ?? 0})

//           </h3>



//           <table className="w-full">

//             <thead>

//               <tr className="border-b border-[#D8D8D8] border-dashed">

//                 <th className="text-center p-2 text-sm font-medium text-[#212121]/70">

//                   #

//                 </th>

//                 <th className="text-left p-2 text-sm font-medium text-[#212121]/70 w-60 truncate line-clamp-1">

//                   SKU(Product Name)

//                 </th>

//                 <th className="text-left p-2 text-sm font-medium text-[#212121]/70">

//                   Quantity

//                 </th>

//                 <th className="text-left p-2 text-sm font-medium text-[#212121]/70">

//                   Reserved Quantity

//                 </th>

//                 {(split || mode === "dropRequest" || (manifest?.products?.some((p: any) => p.note))) && (

//                   <th className="text-left p-2 text-sm font-medium text-[#212121]/70">

//                     Note

//                   </th>

//                 )}



//                 {manifest?.status !== "SENT_TO_CLIENT" && (

//                   <>

//                     <th className="text-left p-2 text-sm font-medium text-[#212121]/70">

//                       Qty (Missing)

//                     </th>

//                     <th className="text-left p-2 text-sm font-medium text-[#212121]/70">

//                       Qty (Damage)

//                     </th>

//                     <th className="text-left p-2 text-sm font-medium text-[#212121]/70">

//                       Admin Reason

//                     </th>

//                     <th className="text-left p-2 text-sm font-medium text-[#212121]/70">

//                       Client Reason

//                     </th>

//                   </>

//                 )}

//                 {/* <th className="text-center p-2 text-sm font-medium text-[#212121]/70">Confirm</th> */}

//               </tr>

//             </thead>



//             <tbody>

//               {manifest?.products?.map((item: Product, i: number) => {

//                 const itemHasIssues =

//                   (item?.missingQty && item.missingQty > 0) ||

//                   (item?.damageQty && item.damageQty > 0) ||

//                   (item?.adminReason && item.adminReason.trim() !== "");



//                 return (

//                   <tr

//                     key={item.productId} // Use product ID for better keying

//                     className="hover:bg-[#FBD037]/20 transition cursor-pointer"

//                   >

//                     <td className="p-3 px-2 text-sm text-[#212121] text-center">

//                       {i + 1}

//                     </td>



//                     <td className="p-3 px-2 text-sm text-[#212121]">

//                       {item.sku} ({item.productName})

//                     </td>



//                     <td className="p-3 px-2 text-sm text-[#212121]">

//                       {item.quantity ?? ""}

//                     </td>



//                     <td className="p-3 px-2 text-sm text-[#212121]">

//                       {item.reservedQuantity ?? ""}

//                     </td>



//                     {(split || mode === "dropRequest" || item?.note) && (

//                       <td className="p-2 text-sm text-[#212121]">

//                         {item.note ?? ""}

//                       </td>

//                     )}



//                     {itemHasIssues && (

//                       <>

//                         <td className="p-3 px-2 text-sm text-[#212121]">

//                           {item?.missingQty ?? ""}

//                         </td>

//                         <td className="p-3 px-2 text-sm text-[#212121]">

//                           {item?.damageQty ?? ""}

//                         </td>

//                         <td className="p-3 px-2 text-sm text-[#212121]">

//                           {item?.adminReason ?? ""}

//                         </td>



//                         {manifest?.status === "VERIFIED_BY_CLIENT" ? (

//                           <td className="p-3 px-2 text-sm text-[#212121]">

//                             {item?.clientReason ?? ""}

//                           </td>

//                         ) : (

//                           <td className="p-2 text-sm text-[#212121]">

//                             <input

//                               placeholder="Write Reason.."

//                               className="rounded-full px-4 py-1.5 text-sm border-[0.5px] border-[#D8D8D8] focus:outline-none w-full"

//                               {...register(`products[${i}].clientReason`)}

//                               defaultValue={item.clientReason ?? ""}

//                             />

//                           </td>

//                         )}



//                         {/* <td className="p-3 px-2 text-sm text-[#212121] text-center">

//                           <input

//                             type="checkbox"

//                             className="w-4 h-4 accent-[#FBD037]"

//                             {...register(`products[${i}].confirmed`)}

//                             defaultChecked={item.confirmed ?? false} // Pre-check if already confirmed

//                           />

//                         </td> */}

//                       </>

//                     )}

//                   </tr>

//                 );

//               })}

//             </tbody>

//           </table>

//         </div>

//       </>

//     );

//   };



//   const renderUpdateMode = () => (

//     <>

//       <div className="grid grid-cols-6 gap-4">

//         <div className="col-span-6">

//           <RaidoField

//             label=""

//             value={mode}

//             onClick={handleModeChange}

//             valuesArr={[

//               { value: "pickupRequest", text: "Pickup Request" },

//               { value: "dropRequest", text: "Drop off Request" },

//             ]}

//           />

//         </div>

//         {mode === "pickupRequest" && (

//           <>

//             <SelectInput

//               selectOptions={[

//                 { id: 1, value: "car", text: "Car" },

//                 { id: 2, value: "van", text: "Van" },

//                 { id: 3, value: "dokker", text: "Dokker" },

//               ]}

//               className="col-span-3"

//               label="Select Vehicle Type"

//               name="vehicleType"

//               placeholder="Select Vehicle Type"

//               validation={{ required: "Vehicle Type is required" }}

//               value={watch?.("vehicleType")}

//               setValue={(val: string) => setValue?.("vehicleType", val)}

//               error={errors?.vehicleType}

//             />

//             <SelectInput

//               className="col-span-3"

//               label="Select Location"

//               selectOptions={allPickupLocationData?.map((loc: any) => ({

//                 id: loc.id,

//                 value: loc.id,

//                 text: loc.full_address,

//               }))}

//               name="locationId"

//               placeholder="Select Location"

//               validation={{ required: "Location is required" }}

//               value={watch?.("locationId")}

//               setValue={(val: string) => setValue?.("locationId", val)}

//               error={errors?.locationId}

//             />

//             <Input

//               className="col-span-3"

//               type="date"

//               name="pickupDate"

//               title="Preferred Date"

//               placeholder="Select Date"

//               validation={{ required: "Pickup Date is required" }}

//               register={register}

//               error={errors?.pickupDate}

//             />

//             <Input

//               className="col-span-3"

//               title="Preferred Time Slot"

//               type="time"

//               name="timeSlot"

//               placeholder="Select Time Slot"

//               validation={{ required: "Time Slot is required" }}

//               register={register}

//               error={errors?.timeSlot}

//             />

//           </>

//         )}

//         {mode === "dropRequest" && (

//           <>

//             <Input

//               className="col-span-3"

//               type="date"

//               name="pickupDate"

//               title="Preferred Pickup Date"

//               placeholder="Select Date"

//               validation={{ required: "Pickup Date is required" }}

//               register={register}

//               error={errors?.pickupDate}

//             />

//             <Input

//               className="col-span-3"

//               title="Preferred Time Slot"

//               type="time"

//               name="timeSlot"

//               placeholder="Select Time Slot"

//               validation={{ required: "Time Slot is required" }}

//               register={register}

//               error={errors?.timeSlot}

//             />

//           </>

//         )}

//         <SelectInput

//           selectOptions={[

//             { id: 1, value: "PALLET", text: "Pallet" },

//             { id: 2, value: "BOX", text: "Box" },

//           ]}

//           className="col-span-6"

//           label="Select Package Type"

//           name="packageType"

//           placeholder="Select Package Type"

//           validation={{ required: "Package Type is required" }}

//           value={watch?.("packageType")}

//           setValue={(val: string) => setValue?.("packageType", val)}

//           error={errors?.packageType}

//         />

//       </div>

//       <div className="col-span-full space-y-2 border-[1.5px] border-[#D2D2D2] p-3 rounded-lg">

//         <div className="flex items-center justify-between">

//           <h3 className="text-[#212121]/70 font-medium text-sm uppercase">

//             Product Info ({manifest?.products?.length ?? 0})

//           </h3>

//           <div className="flex items-center gap-2">

//             <span>Split</span>

//             <ToggleButton onChange={handleSplitToggle} checked={split} />

//           </div>

//         </div>

//         <table className="w-full">

//           <thead>

//             <tr className="border-b border-[#D8D8D8] border-dashed">

//               {split && (

//                 <th className="text-center p-2 text-sm font-medium text-[#212121]/70 w-fit">

//                   <Checkbox

//                     name="splitAll"

//                     label=""

//                     valuesArr={[{ value: "split", text: "" }]}

//                     register={register}

//                     className="inline-block"

//                   />

//                 </th>

//               )}

//               <th className="text-center p-2 text-sm font-medium text-[#212121]/70">

//                 #

//               </th>

//               <th className="text-left p-2 text-sm font-medium text-[#212121]/70">

//                 SKU(Product Name)

//               </th>

//               <th className="text-left p-2 text-sm font-medium text-[#212121]/70">

//                 Quantity

//               </th>



//               {(split || mode === "dropRequest" || (manifest?.products?.some((p: any) => p.note))) && (

//                 <th className="text-left p-2 text-sm font-medium text-[#212121]/70">

//                   Note

//                 </th>

//               )}

//             </tr>

//           </thead>

//           <tbody>

//             {manifest?.products?.map((item: Product, i: number) => (

//               <tr

//                 key={item.productId}

//                 className="hover:bg-[#FBD037]/20 transition cursor-pointer"

//               >

//                 {split && (

//                   <td className="p-2 text-sm text-[#212121] text-center">

//                     <Checkbox

//                       name={`products[${i}].selected`}

//                       label=""

//                       valuesArr={[{ value: "selected", text: "" }]}

//                       register={register}

//                       className="inline-block"

//                     />

//                   </td>

//                 )}

//                 <td className="p-2 text-sm text-[#212121] text-center">

//                   {i + 1}

//                 </td>

//                 <td className="p-2 text-base text-[#212121]">

//                   {item.sku} ({item.productName})

//                   <input

//                     type="hidden"

//                     {...register(`products[${i}].productId`)}

//                     value={item.productId}

//                   />

//                 </td>

//                 <td className="p-2 text-base text-[#212121]">

//                   <div className="space-y-1">

//                     <input

//                       placeholder="Enter Quantity"

//                       type="number"

//                       className="rounded-full px-4 py-1.5 text-sm border-[0.5px] border-[#D8D8D8] focus:outline-none max-w-[150px] w-full"

//                       {...register(`products[${i}].quantity`, {

//                         required: split && watch?.(`products[${i}].selected`) ? "Quantity is required" : false,

//                         min: {

//                           value: 0,

//                           message: "Quantity must be non-negative",

//                         },

//                       })}

//                       defaultValue={item.quantity ?? ""}

//                     />

//                     {errors?.products?.[i]?.quantity && (!split || watch?.(`products[${i}].selected`)) && (

//                       <span className="text-red-500 text-xs block font-light">

//                         {errors.products[i].quantity.message}

//                       </span>

//                     )}

//                   </div>

//                 </td>

//                 {(split || mode === "dropRequest" || item?.note) && (

//                   <td className="p-2 text-base text-[#212121]">

//                     <div className="space-y-1">

//                       <input

//                         placeholder="Write Reason..."

//                         className="rounded-full px-4 py-1.5 text-sm border-[0.5px] border-[#D8D8D8] focus:outline-none max-w-[250px] w-full"

//                         {...register(`products[${i}].note`, {

//                           required: split && watch?.(`products[${i}].selected`) ? "Note is required" : false,

//                         })}

//                       />

//                       {errors?.products?.[i]?.note && (!split || watch?.(`products[${i}].selected`)) && (

//                         <span className="text-red-500 text-xs block font-light">

//                           {errors.products[i].note.message}

//                         </span>

//                       )}

//                     </div>

//                   </td>

//                 )}

//               </tr>

//             ))}

//           </tbody>

//         </table>

//       </div>



//       {/* Hidden form registrations for validation */}

//       {mode === "pickupRequest" && (

//         <>

//           <input type="hidden" {...register("vehicleType", { required: "Vehicle Type is required" })} />

//           <input type="hidden" {...register("locationId", { required: "Location is required" })} />

//         </>

//       )}

//       <input type="hidden" {...register("packageType", { required: "Package Type is required" })} />

//       <input type="hidden" {...register("split")} value={split ? "true" : "false"} />

//     </>

//   );



//   const handleClose = () => {

//     onClose();

//     setIsUpdateMode(false);

//     // Clear form data when modal is closed

//     if (setValue) {

//       setValue("vehicleType", "");

//       setValue("locationId", "");

//       setValue("pickupDate", "");

//       setValue("timeSlot", "");

//       setValue("requestType", "pickupRequest");

//       setValue("packageType", "");

//       setMode("pickupRequest");

//       setSplit(false);



//       // Clear product data

//       manifest?.products?.forEach((_: Product, i: number) => {

//         setValue(`products[${i}].quantity`, "");

//         setValue(`products[${i}].missingQty`, 0);

//         setValue(`products[${i}].damageQty`, 0);

//         setValue(`products[${i}].clientReason`, "");

//         setValue(`products[${i}].confirmed`, false);

//         setValue(`products[${i}].adminReason`, "");

//         setValue(`products[${i}].reservedQuantity`, 0);

//         setValue(`products[${i}].note`, "");

//         setValue(`products[${i}].selected`, false);

//       });

//     }

//   };



//   return (

//     <div

//       className={`fixed top-0 left-0 w-full h-screen bg-black/60 z-50 flex items-center justify-end p-4 ${open ? "block" : "hidden"

//         }`}

//     >

//       <div className="rounded-2xl [@media(min-width:1920px)]:w-7/12 [@media(min-width:1536px)]:w-8/12 relative h-full">

//         <div className="flex items-center">

//           <div className="bg-gradient-to-tr from-[#FDF8E5] to-[#FAF8EC] flex items-center justify-between px-6 py-4 w-full rounded-tl-3xl rounded-tr-[63px]">

//             <h1 className="text-2xl">

//               {isUpdateMode

//                 ? "Update Request"

//                 : manifest?.manifestShortId || "Product Request"}

//             </h1>

//           </div>

//           <div className="relative">

//             <svg

//               xmlns="http://www.w3.org/2000/svg"

//               width={38}

//               height={37}

//               viewBox="0 0 38 37"

//               fill="none"

//               className="absolute -bottom-[10px] -left-[8px] rotate-[-1.8deg]"

//             >

//               <path

//                 d="M0.5 0L4.86189 10.5496C10.4737 24.1222 22.9306 33.645 37.5 35.5L4.91509 37L0.5 0Z"

//                 fill="#F7F6F2"

//               />

//             </svg>

//             <button

//               onClick={handleClose}

//               className="bg-[#F2F2F7] rounded-full p-1 cursor-pointer w-12 h-12 ml-5 flex items-center justify-center flex-shrink-0"

//             >

//               <IconX size={20} />

//             </button>

//           </div>

//         </div>

//         <div

//           className={`w-full py-4 px-6 bg-gradient-to-tr from-[#FDF8E5] to-[#FAF8EC] rounded-tr-[30px]   ${manifest?.status === "CLIENT_UPDATED" ||

//             manifest?.status === "SENT_TO_CLIENT"

//             ? "rounded-b-2xl"

//             : ""

//             }`}

//         >

//           <div className="h-[calc(100vh-12rem)] overflow-y-auto space-y-4 w-full">

//             {isUpdateMode ? renderUpdateMode() : renderViewMode()}

//           </div>

//         </div>



//         <div className="border-t border-[#D8D8D8] px-6 py-4 flex justify-end space-x-2 bg-gradient-to-tr from-[#FDF8E5] to-[#FAF8EC] rounded-b-[30px]">

//           {manifest?.status === "MANIFEST_REQUEST" &&

//             manifest?.createdByName !== profile?.name && (

//               <>

//                 {isUpdateMode && (

//                   <ButtonStyled

//                     value="Cancel"

//                     onClick={() => setIsUpdateMode(false)}

//                     extraClasses="bg-gray-500 hover:bg-gray-600 text-white"

//                   />

//                 )}

//                 <ButtonStyled

//                   value={isUpdateMode ? "Save" : "Update"}

//                   onClick={toggleUpdateMode}

//                 />

//               </>

//             )}



//           {manifest?.status === "ON_HOLD" && (

//             <ButtonStyled

//               value="Confirm"

//               onClick={handleConfirmSubmit} // Use handleConfirmSubmit for the Confirm button

//             />

//           )}

//         </div>

//       </div>

//     </div>

//   );

// };



// export default ProductRequestModal;

/* eslint-disable react-hooks/exhaustive-deps */

/* eslint-disable react-hooks/exhaustive-deps */

import { IconX, IconPackage } from "@tabler/icons-react";
import { useState, useEffect, useCallback } from "react";
import RaidoField from "../../../components/common/RaidoField";
import ToggleButton from "../../../components/ToggleButton";
import { useFetchManifestById, useSplitManifestMutation } from "../../../hooks/productManifest";
import { useFetchAllPickupLocationData } from "../../../apis/pickupApis";
import {
  Control,
  UseFormClearErrors,
  UseFormRegister,
  UseFormSetValue,
  UseFormWatch,
} from "react-hook-form";
import { useSelector } from "react-redux";
import toast from "react-hot-toast";
import NewSelectInput from "../../../components/NewSelectInput";
import NewinputField from "../../../components/NewInput";

interface Product {
  isSplit: boolean;
  productId: string;
  productName: string;
  sku: string;
  quantity?: number | null;
  receivedQty?: number | null;
  missingQty?: number | null;
  damageQty?: number | null;
  adminReason?: string | null;
  clientReason?: string | null;
  confirmed?: boolean;
  note?: string | null;
  reservedQuantity?: number | null;
}

interface Props {
  open: boolean;
  onClose: () => void;
  manifestId?: string;
  register: UseFormRegister<any>;
  setValue?: UseFormSetValue<any>;
  watch?: UseFormWatch<any>;
  errors?: any;
  clearErrors?: UseFormClearErrors<any>;
  control?: Control<any>;
  handleSubmit: any;
  reset?: any;
  onSplitSuccess?: () => void;
  initialUpdateMode?: boolean;
}

type StatusHistory = {
  id: string;
  entityId: string;
  entityType: string;
  oldStatus: string | null;
  newStatus: string;
  changedByUserId: string;
  details: string;
  createdAt: string;
};

const TwoCol: React.FC<{ label: string; value: React.ReactNode }> = ({ label, value }) => (
  <p className="text-sm text-[#1E293B] flex items-center space-x-2">
    <span className="font-normal text-sm text-[#212121]">{label}:</span>
    <span>{value}</span>
  </p>
);

const SectionHeader = ({
  icon: Icon,
  title,
}: {
  icon?: any;
  title: string;
}) => (
  <div className="flex items-center gap-2 relative z-10">
    {Icon && (
      <div className="p-1 rounded-lg bg-yellow-50 text-[#FBD037]">
        <Icon size={16} />
      </div>
    )}
    <h3 className="text-xs font-bold text-[#1E293B] uppercase tracking-wider">
      {title}
    </h3>
  </div>
);



const ProductRequestModal: React.FC<Props> = ({
  open,
  onClose,
  manifestId,
  register,
  setValue,
  watch,
  errors,
  clearErrors,
  reset,
  handleSubmit,
  onSplitSuccess,
  initialUpdateMode,
}) => {
  const today = new Date().toISOString().split("T")[0];
  const profile = useSelector((state: any) => state.auth.profile);

  const [isUpdateMode, setIsUpdateMode] = useState(initialUpdateMode || false);
  const [mode, setMode] = useState<"pickupRequest" | "dropRequest">("pickupRequest");
  const [split, setSplit] = useState(false);
  // Track which productIds are checked for split — independent per row
  const [selectedIds, setSelectedIds] = useState<Set<string>>(new Set());



  const { data: manifest } = useFetchManifestById(manifestId || "");
  const { data: allPickupLocationData } = useFetchAllPickupLocationData();
  const { mutate: splitManifest, isPending: isSplitPending } = useSplitManifestMutation(
    manifestId || ""
  );

  const products: Product[] = Array.isArray(manifest?.products) ? manifest.products : [];
  const unblockedProducts = products.filter((p: any) => !p.isSplit);
  // Split toggle and selection logic only counts unblocked products
  const totalCount = unblockedProducts.length;
  const hasAnySplit = products.some((p: any) => p.isSplit);
  const allChecked = selectedIds.size === totalCount && totalCount > 0;
  const someChecked = selectedIds.size > 0 && !allChecked;

  // ── Checkbox helpers ──────────────────────────────────────────────────────

  const toggleAll = () => {
    if (allChecked) {
      setSelectedIds(new Set());
    } else {
      // Only allow selecting unblocked products
      setSelectedIds(new Set(unblockedProducts.map((p) => p.productId)));
    }
  };

  const toggleOne = (productId: string) => {
    setSelectedIds((prev) => {
      const next = new Set(prev);
      next.has(productId) ? next.delete(productId) : next.add(productId);
      return next;
    });
  };

  useEffect(() => {
    if (open) {
      setIsUpdateMode(initialUpdateMode || false);
    }
  }, [open, initialUpdateMode]);

  // ── Pre-populate form fields ──────────────────────────────────────────────

  useEffect(() => {
    if (manifest) {
      // Reset to view mode when manifest changes
      setIsUpdateMode(initialUpdateMode || false);
      setSplit(false);
      setSelectedIds(new Set());

      const mappedMode =
        manifest.requestType === "PICKUP" || manifest.requestType === "pickupRequest"
          ? "pickupRequest"
          : manifest.requestType === "DROP" || manifest.requestType === "dropRequest"
            ? "dropRequest"
            : "pickupRequest";
      setMode(mappedMode);

      const initialProducts = manifest.products?.map((item: Product) => ({
        productId: item.productId,
        quantity: item.quantity ?? 0,
        missingQty: item.missingQty ?? 0,
        damageQty: item.damageQty ?? 0,
        clientReason: item.clientReason ?? "",
        adminReason: item.adminReason ?? "",
        receivedQty: item.receivedQty ?? 0,
        reservedQuantity: item.reservedQuantity ?? 0,
        note: item.note ?? "",
      })) || [];

      reset({
        vehicleType: manifest.vehicleType,
        locationId: manifest.locationId,
        pickupDate: manifest.pickupDate
          ? new Date(manifest.pickupDate).toISOString().split("T")[0]
          : "",
        timeSlot: manifest.timeSlot,
        requestType: mappedMode,
        packageType: (manifest.packageType === "PALLET" || manifest.packageType === "Pallet") ? "PALLET" : (manifest.packageType === "BOX" || manifest.packageType === "Box") ? "BOX" : "",
        products: initialProducts,
      });
    }
  }, [manifest]);

  // ── Split toggle ──────────────────────────────────────────────────────────

  const handleSplitToggle = useCallback(() => {
    setSplit((prev) => {
      if (prev) {
        // Turning split OFF — clear selections
        setSelectedIds(new Set());
      }
      return !prev;
    });
  }, []);

  const formatDateWithTime = (isoDateString: string | null | undefined): string => {
    if (!isoDateString) return "";

    const date = new Date(isoDateString);
    if (isNaN(date.getTime())) return "";

    const day = date.getDate();
    const month = date.toLocaleString("default", { month: "short" });
    const year = date.getFullYear();

    const hours = date.getHours();
    const minutes = date.getMinutes().toString().padStart(2, "0");

    return `${day} ${month} ${year}, ${hours}:${minutes}`;
  };

  // ── Primary action (Save button) ──────────────────────────────────────────

  const toggleUpdateMode = useCallback(() => {
    if (!isUpdateMode) {
      setIsUpdateMode(true);
      return;
    }

    // In update mode — decide: split or normal update

    if (!split) {
      // Split OFF → always normal update
      handleSubmit();
      return;
    }

    // Split ON, nothing selected → block
    if (selectedIds.size === 0) {
      toast.error("Please select at least one product to split.");
      return;
    }

    // Split ON, ALL selected → treat as normal update (no empty parent)
    if (selectedIds.size === totalCount && !hasAnySplit) {
      handleSubmit();
      return;
    }

    // Split ON, partial selection → call split API.
    // Read current form values so the child manifest gets the user's
    // updated metadata (date, time, vehicle, location, products with
    // quantities/notes) — same payload shape as a normal update.
    const currentProducts = manifest?.products?.map((item: Product, i: number) => ({
      productId: item.productId,
      quantity: watch?.(`products[${i}].quantity`) ?? item.quantity ?? 0,
      missingQty: watch?.(`products[${i}].missingQty`) ?? item.missingQty ?? 0,
      damageQty: watch?.(`products[${i}].damageQty`) ?? item.damageQty ?? 0,
      clientReason: watch?.(`products[${i}].clientReason`) ?? item.clientReason ?? "",
      adminReason: watch?.(`products[${i}].adminReason`) ?? item.adminReason ?? "",
      note: watch?.(`products[${i}].note`) ?? item.note ?? "",
      receivedQty: watch?.(`products[${i}].receivedQty`) ?? item.receivedQty ?? 0,
      reservedQuantity: watch?.(`products[${i}].reservedQuantity`) ?? item.reservedQuantity ?? 0,
    })) ?? [];

    const formPayload = {
      requestType: watch?.("requestType") ?? mode,
      vehicleType: watch?.("vehicleType") ?? manifest?.vehicleType,
      locationId: watch?.("locationId") ?? manifest?.locationId,
      pickupDate: watch?.("pickupDate") ?? manifest?.pickupDate,
      timeSlot: watch?.("timeSlot") ?? manifest?.timeSlot,
      packageType: watch?.("packageType") ?? manifest?.packageType,
      products: currentProducts,
    };

    const validSelectedIds = Array.from(selectedIds).filter(
      (id) => !products.find((p) => p.productId === id && p.isSplit)
    );

    if (validSelectedIds.length === 0) {
      toast.error("Selected products are already split and cannot be split again.");
      return;
    }

    splitManifest(
      {
        selectedProductIds: Array.from(selectedIds),
        ...formPayload,
      },
      {
        onSuccess: () => {
          setSplit(false);
          setSelectedIds(new Set());
          setIsUpdateMode(false);
          reset();
          onSplitSuccess?.();
          handleClose();
        },
        onError: (error: any) => {
          const message =
            error?.message ||
            error?.response?.message ||
            "Failed to split manifest. Please try again.";
          toast.error(message);
        },
      }
    );
  }, [isUpdateMode, split, selectedIds, totalCount, handleSubmit, splitManifest, onSplitSuccess]);

  const handleModeChange = useCallback(
    (val: string | false | undefined) => {
      if (typeof val === "string") {
        setMode(val as "pickupRequest" | "dropRequest");
        setValue?.("requestType", val);
      }
    },
    [setValue]
  );

  const handleConfirmSubmit = useCallback(() => {
    handleSubmit();
  }, [handleSubmit]);

  // ── Derive button label ───────────────────────────────────────────────────

  const saveLabel = (() => {
    if (!isUpdateMode) return "Update";
    if (isSplitPending) return "Splitting...";
    if (split && selectedIds.size > 0 && selectedIds.size < totalCount) return "Split & Create";
    return "Save";
  })();

  // ── View mode render ──────────────────────────────────────────────────────

  const renderViewMode = () => (
    <>
      {manifest?.status !== "ON_HOLD" && (
        <div className="w-full p-4  shadow-sm border border-[#D2D2D2] rounded-2xl space-y-4">
          <h2 className="text-[#212121]/70 font-medium text-sm uppercase">
            Timeline
          </h2>

          <div className="flex items-center justify-between relative">
            {manifest?.statusHistories?.map(
              (
                item: StatusHistory,
                index: number,
                array: StatusHistory[],
              ) => {
                const currentStep = array.length - 1;
                const isCompleted = index < currentStep;
                const isCurrent = index === currentStep;

                return (
                  <div
                    key={item.id}
                    className="flex-1 flex flex-col items-center relative"
                  >
                    {index !== array.length - 1 && (
                      <div
                        className={`absolute top-2.5 left-1/2 w-full h-[2px] z-0 ${index < currentStep ? "bg-green-500" : "bg-gray-300"
                          }`}
                      />
                    )}

                    <div
                      className={`z-10 w-6 h-6 rounded-full flex items-center justify-center border
                  ${isCompleted
                          ? "bg-green-500 border-green-500"
                          : isCurrent
                            ? "bg-[#FBD037] border-[#FBD037]"
                            : "bg-white border-gray-300"
                        }`}
                    >
                      {isCompleted && (
                        <svg
                          className="w-3 h-3 text-white"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth={3}
                          viewBox="0 0 24 24"
                        >
                          <path d="M5 13l4 4L19 7" />
                        </svg>
                      )}

                      {isCurrent && (
                        <div className="w-2 h-2 bg-white rounded-full" />
                      )}
                    </div>

                    <div className="mt-2 text-center px-2 cursor-pointer relative group">
                      <p
                        className={`text-sm font-medium ${isCompleted || isCurrent
                          ? "text-black"
                          : "text-gray-400"
                          }`}
                      >
                        {item?.newStatus
                          ?.replace(/_/g, " ")
                          .toLowerCase()
                          .replace(/\b\w/g, (char: string) =>
                          char.toUpperCase(),
                          )}
                      </p>

                      {item?.details && (
                        <div
                          className={`absolute flex justify-center items-center -top-16  mt-2 opacity-0 group-hover:opacity-100 transition duration-200 z-50 ${index === 0 ? "left-0 translate-x-0" : index === array.length - 1 ? "right-0 translate-x-0" : "left-1/2 -translate-x-1/2"}`}
                        >
                          <div className="px-3 py-1 bg-black rounded-md space-y-1 shadow-lg whitespace-nowrap">
                            <p className=" text-white text-xs ">
                              {item.details}
                            </p>
                            <p className="text-xs text-white">
                              {formatDateWithTime(item?.createdAt)}
                            </p>
                          </div>

                          {/* ARROW */}
                          <div
                            className={`w-2 h-2 bg-black rotate-45 absolute -bottom-1 ${index === 0 ? "left-3" : index === array.length - 1 ? "right-3" : "left-1/2 -translate-x-1/2"}`}
                          ></div>
                        </div>
                      )}
                    </div>
                  </div>
                );
              },
            )}
          </div>
        </div>
      )}

      {manifest?.status !== "ON_HOLD" && (
        <div className="col-span-full space-y-3 border-[1.5px] border-[#D2D2D2] p-3 rounded-lg">
          <h3 className="text-[#212121]/70 font-medium text-sm uppercase">Client Info</h3>
          <div className="grid grid-cols-2 gap-2">
            <TwoCol label="Client ID" value={manifest?.clientId} />
            <TwoCol label="Name" value={manifest?.clientName} />
            <TwoCol label="Mobile" value={manifest?.clientMobileNo} />
            <TwoCol label="Email" value={manifest?.clientEmail} />
          </div>
        </div>
      )}

      <div className={manifest?.status === "ON_HOLD" ? "col-span-full space-y-2" : "col-span-full space-y-2 border-[1.5px] border-[#D2D2D2] p-3 rounded-lg"}>
        <h3 className="text-[#212121]/70 font-medium text-sm uppercase">
          Product Info ({manifest?.products?.length ?? 0})
        </h3>
        {manifest?.status === "ON_HOLD" ? (
          <div className="space-y-4">
            {manifest?.products?.map((item: Product, i: number) => (
              <div key={item.productId || i} className="p-4 space-y-3">
                {/* Product Title */}
                <div className="flex justify-between items-start border-b border-gray-100 pb-2 mb-2">
                  <span className="font-bold text-sm text-[#212121]">
                    {item.sku} {item.productName && `(${item.productName})`}
                  </span>
                  <span className="text-xs bg-slate-100 text-slate-600 px-2 py-0.5 rounded-md font-semibold">
                    SN: {i + 1}
                  </span>
                </div>

                {/* Details List (Key-Value) */}
                <div className="space-y-2">
                  <div className="flex justify-between items-center text-xs">
                    <span className="text-slate-500 font-medium">Quantity :</span>
                    <span className="text-slate-800 font-bold">{item.quantity && item.quantity > 0 ? item.quantity : "0"}</span>
                  </div>

                  <div className="flex justify-between items-center text-xs">
                    <span className="text-slate-500 font-medium">Rec. Qty. :</span>
                    <span className="text-slate-800 font-semibold">{item.receivedQty ?? 0}</span>
                  </div>

                  <div className="flex justify-between items-center text-xs">
                    <span className="text-slate-500 font-medium">Qty (Missing) :</span>
                    <span className="text-amber-600 font-bold">{item.missingQty ?? 0}</span>
                  </div>

                  <div className="flex justify-between items-center text-xs">
                    <span className="text-slate-500 font-medium">Qty (Damage) :</span>
                    <span className="text-red-600 font-bold">{item.damageQty ?? 0}</span>
                  </div>

                  {item?.adminReason && (
                    <div className="flex justify-between items-start text-xs gap-4">
                      <span className="text-slate-500 font-medium flex-shrink-0">Admin Reason :</span>
                      <span className="text-slate-800 text-right break-words">{item.adminReason}</span>
                    </div>
                  )}

                  {/* Hidden inputs to preserve React Hook Form registration */}
                  <input type="hidden" {...register(`products[${i}].receivedQty`)} defaultValue={item.receivedQty ?? 0} />
                  <input type="hidden" {...register(`products[${i}].missingQty`)} defaultValue={item.missingQty ?? 0} />
                  <input type="hidden" {...register(`products[${i}].damageQty`)} defaultValue={item.damageQty ?? 0} />

                  {/* Client Reason Input */}
                  <div className="flex flex-col gap-1.5 pt-2 border-t border-dashed border-gray-100">
                    <span className="text-xs text-slate-500 font-medium">Client Reason :</span>
                    <input
                      placeholder="Write Reason.."
                      className="rounded-xl px-3 py-2 text-xs border border-[#D2D2D2] focus:outline-none w-full bg-white text-slate-800 focus:border-[#FBD037]"
                      {...register(`products[${i}].clientReason`)}
                      defaultValue={item.clientReason ?? ""}
                    />
                  </div>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="overflow-x-auto w-full">
            <table className="w-full min-w-[700px]">
              <thead>
                <tr className="border-b border-[#D8D8D8] border-dashed">
                  <th className="text-center p-2 text-sm font-medium text-[#212121]/70">SN</th>
                  <th className="text-left p-2 text-sm font-medium text-[#212121]/70 w-60 truncate">
                    SKU(Product Name)
                  </th>
                  {manifest?.status !== "MANIFEST_REQUEST" && (
                    <>
                      <th className="text-left p-2 text-sm font-medium text-[#212121]/70">Quantity</th>
                      <th className="text-left p-2 text-sm font-medium text-[#212121]/70">Rec. Qty.</th>
                      {manifest?.status === "COMPLETED" && (
                        <th className="text-left p-2 text-sm font-medium text-[#212121]/70">Res. Qty.</th>
                      )}
                      {(split || mode === "dropRequest" || manifest?.products?.some((p: any) => p.note)) && (
                        <th className="text-left p-2 text-sm font-medium text-[#212121]/70">Note</th>
                      )}
                      {manifest?.status !== "SENT_TO_CLIENT" && (
                        <>
                          <th className="text-left p-2 text-sm font-medium text-[#212121]/70">Qty (Missing)</th>
                          <th className="text-left p-2 text-sm font-medium text-[#212121]/70">Qty (Damage)</th>
                          <th className="text-left p-2 text-sm font-medium text-[#212121]/70">Admin Reason</th>
                          <th className="text-left p-2 text-sm font-medium text-[#212121]/70">Client Reason</th>
                        </>
                      )}
                    </>
                  )}
                  {manifest?.status === "MANIFEST_REQUEST" && (
                    <th className="text-left p-2 text-sm font-medium text-[#212121]/70">
                      {manifest?.products?.some((p: any) => p.quantity && p.quantity > 0) ? "Quantity" : ""}
                    </th>
                  )}
                </tr>
              </thead>
              <tbody>
                {manifest?.products?.map((item: Product, i: number) => {


                  return (
                    <tr key={item.productId} className="hover:bg-[#FBD037]/20 transition cursor-pointer">
                      <td className="p-3 px-2 text-sm text-[#212121] text-center">{i + 1}</td>
                      <td className="p-3 px-2 text-sm text-[#212121]">{item.sku} {item.productName && `(${item.productName})`}</td>
                      {manifest?.status !== "MANIFEST_REQUEST" && (
                        <>
                          <td className="p-3 px-2 text-sm text-[#212121]">{item.quantity && item.quantity > 0 ? item.quantity : ""}</td>
                          <td className="p-2 text-sm text-[#212121]">
                            <input
                              type="number"
                              placeholder="Rec. Qty"
                              className="rounded-full px-4 py-1.5 text-sm border-[0.5px] border-[#D8D8D8] focus:outline-none w-full bg-gray-50"
                              {...register(`products[${i}].receivedQty`)}
                              defaultValue={item.receivedQty ?? 0}
                              readOnly
                            />
                          </td>
                        </>
                      )}
                      {manifest?.status === "COMPLETED" && (
                        <td className="p-3 px-2 text-sm text-[#212121]">{item.reservedQuantity && item.reservedQuantity > 0 ? item.reservedQuantity : ""}</td>
                      )}
                      {(split || mode === "dropRequest" || item?.note) && (
                        <td className="p-2 text-sm text-[#212121]">{item.note ?? ""}</td>
                      )}
                      {manifest?.status !== "MANIFEST_REQUEST" && (
                        <>
                          <td className="p-2 text-sm text-[#212121]">
                            <input
                              type="number"
                              placeholder="Missing"
                              className="rounded-full px-4 py-1.5 text-sm border-[0.5px] border-[#D8D8D8] focus:outline-none w-full bg-gray-50"
                              {...register(`products[${i}].missingQty`)}
                              defaultValue={item.missingQty ?? 0}
                              readOnly
                            />
                          </td>
                          <td className="p-2 text-sm text-[#212121]">
                            <input
                              type="number"
                              placeholder="Damage"
                              className="rounded-full px-4 py-1.5 text-sm border-[0.5px] border-[#D8D8D8] focus:outline-none w-full bg-gray-50"
                              {...register(`products[${i}].damageQty`)}
                              defaultValue={item.damageQty ?? 0}
                              readOnly
                            />
                          </td>
                          <td className="p-3 px-2 text-sm text-[#212121]">{item?.adminReason ?? ""}</td>
                          {manifest?.status === "VERIFIED_BY_CLIENT" ? (
                            <td className="p-3 px-2 text-sm text-[#212121]">{item?.clientReason ?? ""}</td>
                          ) : (
                            <td className="p-2 text-sm text-[#212121]">
                              <input
                                placeholder="Write Reason.."
                                className={`rounded-full px-4 py-1.5 text-sm border-[0.5px] border-[#D8D8D8] focus:outline-none w-full ${
                                  manifest?.status === "ON_HOLD" ? "bg-white" : "bg-gray-50"
                                }`}
                                {...register(`products[${i}].clientReason`)}
                                defaultValue={item.clientReason ?? ""}
                                readOnly={manifest?.status !== "ON_HOLD"}
                              />
                            </td>
                          )}
                        </>
                      )}
                      {manifest?.status === "MANIFEST_REQUEST" && (
                        <td className="p-3 px-2 text-sm text-[#212121]">{item.quantity ? (item.quantity > 0 ? item.quantity : "") : ""}</td>
                      )}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </>
  );

  // ── Update mode render ────────────────────────────────────────────────────

  const renderUpdateMode = () => (
    <div className="w-full py-4 px-6 space-y-4">
      {/* Card 1: Product Request Setup */}
      <div className="space-y-3">
        <SectionHeader title="Product Request Setup" />
        <div className="flex flex-col gap-4 relative z-10">
          <RaidoField
            label=""
            value={mode}
            onClick={handleModeChange}
            valuesArr={[
              { value: "pickupRequest", text: "Pickup Request" },
              { value: "dropRequest", text: "Drop off Request" },
            ]}
          />
          <NewSelectInput
            label="Select Package Type"
            name="packageType"
            value={watch?.("packageType")}
            clearErrors={clearErrors}
            register={register}
            error={errors?.packageType}
            validation={{ required: "Package Type is required" }}
            onChange={(val) => {
              setValue?.("packageType", val);
              setValue?.("reqType", (val === "PALLET" || val === "Pallet") ? "PALLET" : "QUANTITY");
            }}
            selectOptions={[
              { id: "PALLET", value: "PALLET", text: "Pallet" },
              { id: "BOX", value: "BOX", text: "Box" },
            ]}
            className="flex items-center justify-between"
            labelClass="w-full"
            fullWidthDropdown={true}
          />
          {mode === "pickupRequest" && (
            <>
              <NewSelectInput
                label="Select Vehicle Type"
                name="vehicleType"
                value={watch?.("vehicleType")}
                clearErrors={clearErrors}
                register={register}
                error={errors?.vehicleType}
                validation={{ required: "Vehicle Type is required" }}
                onChange={(val) => setValue?.("vehicleType", val)}
                selectOptions={[
                  { id: "car", value: "car", text: "Car" },
                  { id: "van", value: "van", text: "Van" },
                  { id: "dokker", value: "dokker", text: "Dokker" },
                ]}
                className="flex items-center justify-between"
                labelClass="w-full"
                fullWidthDropdown={true}
              />
              <NewSelectInput
                label="Select Location"
                name="locationId"
                value={watch?.("locationId")}
                clearErrors={clearErrors}
                register={register}
                error={errors?.locationId}
                validation={{ required: "Location is required" }}
                onChange={(val) => setValue?.("locationId", val)}
                selectOptions={allPickupLocationData?.map((loc: any) => ({
                  id: loc.id,
                  value: loc.id,
                  text: loc.full_address,
                })) || []}
                className="flex items-center justify-between"
                labelClass="w-full"
                fullWidthDropdown={true}
              />
            </>
          )}
          <NewinputField
            title={mode === "pickupRequest" ? "Pickup Date" : "Preferred Pickup Date"}
            type="date"
            name="pickupDate"
            register={register}
            error={errors?.pickupDate}
            validation={{ required: "Pickup Date is required" }}
            min={today}
            className="flex items-center justify-between"
            labelClass="w-full"
          />
          <NewinputField
            title="Preferred Time Slot"
            type="time"
            name="timeSlot"
            register={register}
            error={errors?.timeSlot}
            validation={{ required: "Time Slot is required" }}
            className="flex items-center justify-between"
            labelClass="w-full"
          />
        </div>
      </div>

      {/* Card 2: Select Products */}
      <div className="space-y-3">
        <div className="flex items-center justify-between relative z-10">
          <div className="flex items-center gap-2">
            <SectionHeader title="Product Info" />
            {split && selectedIds.size > 0 && (
              <span
                className={`text-[10px] px-2 py-0.5 rounded-full border font-medium ${selectedIds.size === totalCount
                  ? "bg-blue-50 border-blue-300 text-blue-700"
                  : "bg-amber-50 border-amber-300 text-amber-700"
                  }`}
              >
                {selectedIds.size === totalCount
                  ? "All selected → normal update"
                  : `${selectedIds.size} selected → will split`}
              </span>
            )}
          </div>
          <div className="flex items-center gap-1.5">
            <ToggleButton onChange={handleSplitToggle} checked={split} disabled={totalCount <= 1} />
            <span className="text-[#3A3A3C] text-xs font-semibold">
              Split
            </span>
          </div>
        </div>

        {/* Instruction banner */}
        {split && (
          <p className="text-xs text-[#212121]/50 bg-[#FBD037]/10 border border-[#FBD037]/40 rounded-md px-3 py-2 relative z-10">
            Select the <strong>unblocked</strong> products to move into a new manifest (
            <strong>{manifest?.manifestShortId}-{(manifest?.splitCount ?? 0) + 1}</strong>).
            Selecting all active items performs a normal update instead.
            {hasAnySplit && (
              <span className="block mt-1 text-amber-600 font-medium">
                ⚠ This manifest has existing splits. Saving without split will also create a new child for remaining products.
              </span>
            )}
          </p>
        )}

        <div className="overflow-x-auto relative z-10">
          <table className="w-full text-left">
            <thead>
              <tr className="border-b border-[#D8D8D8]/70 text-slate-400 text-[10px] font-bold uppercase tracking-wider">
                {/* Select-all checkbox — only in split mode */}
                {split && (
                  <th className="pb-3 pl-2 w-10">
                    <label className="relative flex items-center cursor-pointer">
                      <input
                        type="checkbox"
                        checked={allChecked}
                        ref={(el) => { if (el) el.indeterminate = someChecked; }}
                        onChange={toggleAll}
                        className="peer h-4.5 w-4.5 cursor-pointer appearance-none rounded border border-slate-300
                          checked:border-[#FBD037] bg-white checked:bg-[#FBD037] checked:text-white"
                      />
                      <span className="absolute text-[10px] font-bold text-white peer-checked:opacity-100 opacity-0 transition-opacity duration-200 top-1/2 left-[9px] transform -translate-x-1/2 -translate-y-1/2 pointer-events-none">
                        ✓
                      </span>
                    </label>
                  </th>
                )}
                <th className="pb-3 pl-2 w-12">SN</th>
                <th className="pb-3">SKU(Product Name)</th>
                <th className="pb-3 w-32">Quantity</th>
                {(split || mode === "dropRequest" || manifest?.products?.some((p: any) => p.note)) && (
                  <th className="pb-3">Note</th>
                )}
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-100">
              {products.map((item: Product & { isSplit?: boolean }, i: number) => {
                const isBlocked = !!item.isSplit;
                const isChecked = selectedIds.has(item.productId);

                if (isBlocked) {
                  return (
                    <tr
                      key={item.productId}
                      className="opacity-40 cursor-not-allowed bg-gray-50/50"
                    >
                      {split && (
                        <td className="py-3 pl-2">
                          <label className="relative flex items-center cursor-not-allowed">
                            <input
                              type="checkbox"
                              disabled
                              checked={false}
                              className="h-4.5 w-4.5 appearance-none rounded border border-slate-200 bg-gray-100 cursor-not-allowed"
                            />
                          </label>
                        </td>
                      )}
                      <td className="py-3 pl-2 text-xs font-semibold text-slate-500">{i + 1}</td>
                      <td className="py-3 text-xs font-medium text-slate-700">
                        <div className="flex items-center gap-2">
                          {item.sku} ({item.productName})
                          <span className="text-[10px] bg-slate-100 text-slate-500 px-2 py-0.5 rounded-full border border-slate-200">
                            Split
                          </span>
                        </div>
                        <input type="hidden" {...register(`products[${i}].productId`)} value={item.productId} />
                      </td>
                      <td className="py-3 pr-2">
                        <input
                          type="number"
                          disabled
                          value={item.quantity ?? ""}
                          className="w-full rounded-xl py-1.5 px-3 text-xs outline-none bg-slate-50 border border-slate-200 text-slate-400 cursor-not-allowed"
                        />
                      </td>
                      {(split || mode === "dropRequest" || item?.note) && (
                        <td className="py-3">
                          <input
                            disabled
                            value={item.note ?? ""}
                            className="w-full rounded-xl py-1.5 px-3 text-xs outline-none bg-slate-50 border border-slate-200 text-slate-400 cursor-not-allowed"
                          />
                        </td>
                      )}
                    </tr>
                  );
                }

                return (
                  <tr
                    key={item.productId}
                    onClick={() => split && toggleOne(item.productId)}
                    className={`transition cursor-pointer ${split && isChecked ? "bg-[#FBD037]/10" : "hover:bg-slate-50/80"}`}
                  >
                    {split && (
                      <td
                        className="py-3 pl-2"
                        onClick={(e) => e.stopPropagation()}
                      >
                        <label className="relative flex items-center cursor-pointer">
                          <input
                            type="checkbox"
                            checked={isChecked}
                            onChange={() => toggleOne(item.productId)}
                            className="peer h-4.5 w-4.5 cursor-pointer appearance-none rounded border border-slate-300
                              checked:border-[#FBD037] bg-white checked:bg-[#FBD037] checked:text-white"
                          />
                          <span className="absolute text-[10px] font-bold text-white peer-checked:opacity-100 opacity-0 transition-opacity duration-200 top-1/2 left-[9px] transform -translate-x-1/2 -translate-y-1/2 pointer-events-none">
                            ✓
                          </span>
                        </label>
                      </td>
                    )}

                    <td className="py-3 pl-2 text-xs font-semibold text-slate-700">{i + 1}</td>

                    <td className="py-3 text-xs font-medium text-slate-700">
                      {item.sku} ({item.productName})
                      <input type="hidden" {...register(`products[${i}].productId`)} value={item.productId} />
                    </td>

                    <td
                      className="py-3 pr-2"
                      onClick={(e) => e.stopPropagation()}
                    >
                      <div className="space-y-1">
                        <input
                          type="number"
                          min={1}
                          step="1"
                          placeholder="Enter Quantity"
                          className="w-full rounded-xl py-1.5 px-3 text-xs outline-none bg-white border border-[#D8D8D8] text-slate-700 focus:border-[#FBD037] transition"
                          {...register(`products[${i}].quantity`, {
                            required: "Quantity is required",
                            min: { value: 1, message: "Quantity must be at least 1" },
                          })}
                          defaultValue={item.quantity ?? ""}
                        />
                        {errors?.products?.[i]?.quantity && (
                          <span className="text-red-500 text-[10px] block font-light">
                            {errors.products[i].quantity.message}
                          </span>
                        )}
                      </div>
                    </td>

                    {(split || mode === "dropRequest" || item?.note) && (
                      <td className="py-3" onClick={(e) => e.stopPropagation()}>
                        <input
                          placeholder="Write Reason..."
                          className="w-full rounded-xl py-1.5 px-3 text-xs outline-none bg-white border border-[#D8D8D8] text-slate-700 focus:border-[#FBD037] transition"
                          {...register(`products[${i}].note`)}
                        />
                      </td>
                    )}
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>

        {/* Footer hint */}
        {split && selectedIds.size === 0 && (
          <p className="text-[10px] text-slate-400 pt-1 relative z-10">
            Select products above to split, or toggle split off to update normally.
          </p>
        )}
      </div>

      {/* Hidden registrations */}
      {mode === "pickupRequest" && (
        <>
          <input type="hidden" {...register("vehicleType", { required: "Vehicle Type is required" })} />
          <input type="hidden" {...register("locationId", { required: "Location is required" })} />
        </>
      )}
      <input type="hidden" {...register("packageType", { required: "Package Type is required" })} />
    </div>
  );

  // ── Close handler ─────────────────────────────────────────────────────────

  const handleClose = () => {
    onClose();
    setIsUpdateMode(false);
    setSplit(false);
    setSelectedIds(new Set());
    if (setValue) {
      setValue("vehicleType", "");
      setValue("locationId", "");
      setValue("pickupDate", "");
      setValue("timeSlot", "");
      setValue("requestType", "pickupRequest");
      setValue("packageType", "");
      setMode("pickupRequest");
      manifest?.products?.forEach((_: Product, i: number) => {
        setValue(`products[${i}].quantity`, 0);
        setValue(`products[${i}].missingQty`, 0);
        setValue(`products[${i}].damageQty`, 0);
        setValue(`products[${i}].clientReason`, "");
        setValue(`products[${i}].confirmed`, false);
        setValue(`products[${i}].adminReason`, "");
        setValue(`products[${i}].receivedQty`, 0);
        setValue(`products[${i}].reservedQuantity`, 0);
        setValue(`products[${i}].note`, "");
        setValue(`products[${i}].selected`, false);
      });
    }
  };

  // ── Render ────────────────────────────────────────────────────────────────

  return (
    <div className="relative border rounded-lg border-gray-200 flex flex-col overflow-hidden  w-full h-full lg:h-[calc(100vh-170px)]">
      {/* Header */}
      <div className="flex items-center justify-between px-6 py-4 flex-shrink-0">
        <h2 className="text-base font-bold text-[#212121]">
          {isUpdateMode ? "Update Request" : manifest?.manifestShortId || "Product Request"}
        </h2>
        <div className="flex items-center gap-2">
          {isUpdateMode ? (
            <button
              type="button"
              onClick={toggleUpdateMode}
              className="px-4 py-2 bg-[#FBD037] hover:bg-yellow-400 text-black rounded-xl text-xs font-bold transition flex items-center gap-1.5"
            >
              {saveLabel}
            </button>
          ) : (
            (manifest?.status === "MANIFEST_REQUEST" || manifest?.status === "ON_PROCESS") &&
            manifest?.createdByName !== profile?.name && (
              <button
                type="button"
                onClick={toggleUpdateMode}
                className="px-4 py-2 bg-[#FBD037] hover:bg-yellow-400 text-black rounded-xl text-xs font-bold transition flex items-center gap-1.5"
              >
                Update
              </button>
            )
          )}

          {manifest?.status === "ON_HOLD" && !isUpdateMode && (
            <button
              type="button"
              onClick={handleConfirmSubmit}
              className="px-4 py-2 bg-[#FBD037] hover:bg-yellow-400 text-black rounded-xl text-xs font-bold transition flex items-center gap-1.5"
            >
              Confirm
            </button>
          )}

          <button
            type="button"
            onClick={handleClose}
            className="p-1.5 rounded-lg border border-[#D2D2D2] hover:bg-gray-100 transition-colors"
          >
            <IconX size={16} />
          </button>
        </div>
      </div>

      {/* Body */}
      <div className={`flex-1 overflow-y-auto ${isUpdateMode ? "pb-6 " : manifest?.status === "ON_HOLD" ? "p-6 space-y-6" : "p-6 bg-slate-50/50 space-y-6"}`}>
        {isUpdateMode ? renderUpdateMode() : renderViewMode()}
      </div>
    </div>
  );
};

export default ProductRequestModal;